import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

import {
  Row,
  Col,
  Button,
  Card,
  Modal,
  Menu,
  Input,
  Form,
  DatePicker,
  TimePicker,
  Select,
  AutoComplete,
  Spin,
  Checkbox,
  message,
  Radio,
} from "antd";
import TextArea from "antd/lib/input/TextArea";

import { ArrowLeftOutlined } from "@ant-design/icons";
import moment from "moment";
import AppConfigs from "../../Config/AppConfig";
import { add, list } from "../../api/Apis";
import { listProducts } from "../../api/AllApis";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { formatPhoneNumber } from "../commonFunctions";
import ErrorPage from "../ErrorPage";

const { Option } = Select;
const dateFormat = "MM/DD/YYYY";
const timeFormat = "hh:mm A";

class AddLoad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      generalInfo: [],
      visible: false,
      dataSource: [],
      loading: false,
      confirmDirty: false,
      startOpen: false,
      endOpen: false,
      startValue: "",
      endValue: "",
      yardLocations: [],
      customersList: [],
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      carriersList: [],
      pageLoading: true,
      selectedCustomer: this.props.location?.state?.customerData || {},
      productsData: [],
      selectedProduct: {},
      loadOriginLocation: [],
      isPallet:
        this.props.location?.state?.leadData?.["cartItems"] &&
        this.props.location?.state?.leadData?.["cartItems"]?.[0]?.[
          "measurementType"
        ] === "Pallet",
      displayQuantity:
        this.props.location?.state?.leadData?.["cartItems"] &&
        this.props.location?.state?.leadData?.["cartItems"]?.[0]?.[
          "measurementType"
        ] === "Pallet",
    };
  }

  setStartValue = (value) => {
    this.setState({
      startValue: value,
    });
    // this.changeFieldValue(value,index,id);
  };
  setEndValue = (value) => {
    if (!value) {
      if (
        this.props.form.getFieldValue("deliveryTime") >
        this.props.form.getFieldValue("deliveryEndTime")
      ) {
        message.error("Please select valid time");
        this.props.form.setFieldsValue({
          deliveryEndTime: null,
        });
        return;
      } else {
        this.props.form.setFieldsValue({
          deliveryEndTime: this.props.form.getFieldValue("deliveryEndTime"),
        });
      }
      //   this.changeFieldValue(value,index,id);
    }
  };
  componentDidMount = async () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let query = {
      approvalStatus: "A",
    };
    list(AppConfigs["entityNames"]["registrations"], query).then((result) => {
      if (result.success) {
        let customersList = result.data.sort((a, b) =>
          parseInt(a["createdAt"]) < parseInt(b["createdAt"]) ? 1 : -1
        );
        this.setState({
          customersList: customersList.filter(
            (item) => item.registrationType === "customer"
          ),
          //filter out the carriers with the blank company name

          carriersList: customersList.filter(
            (item) =>
              item.registrationType === "carrier" &&
              item.companyName !== "" &&
              item.companyName !== null
          ),
          yardLocations: orgDetails["yardLocations"],
          pageLoading: false,
        });
      } else {
        this.setState({
          pageLoading: false,
        });
        console.log(result.errors);
      }
    });
    let newquery = {
      customerId: this.props.location?.state?.leadData?.customerId,
      isActive: true,
    };
    let productsData = await listProducts(newquery);
    let selectedProduct = {};
    if (this.props.location?.state?.leadData) {
      this.props.form.setFieldsValue({
        rateOption:
          this.props.location?.state?.leadData?.rateOption === "flat"
            ? this.props.location?.state?.leadData?.rateOption
            : "measurementType",
      });
      let productsDataFinal = [];
      if (productsData.products) {
        productsDataFinal = [
          ...productsData.products["Bulk Gravel"],
          ...productsData.products["Palletized Stone"],
        ];
      } else {
        productsDataFinal = [...productsData];
      }
      selectedProduct = productsDataFinal.filter(
        (product) =>
          product.id === this.props.location?.state?.leadData?.productId
      );
    }
    let loadOriginLocation = [];
    if (selectedProduct.length > 0) {
      this.state.yardLocations.map((loc) => {
        if (Array.isArray(selectedProduct[0].productOrigin)) {
          return selectedProduct[0].productOrigin?.map((item) => {
            if (loc.id === item) loadOriginLocation.push(loc);
          });
        } else {
          if (loc.id === selectedProduct[0].productOrigin)
            loadOriginLocation.push(loc);
        }
      });
    }
    console.log("loadOriginLocation", loadOriginLocation);
    if (productsData.products) {
      this.setState({
        productsData: [
          ...productsData.products["Bulk Gravel"],
          ...productsData.products["Palletized Stone"],
        ],
        selectedProduct: selectedProduct,
        loadOriginLocation: loadOriginLocation,
      });
    } else {
      this.setState({
        productsData: [...productsData],
        selectedProduct: selectedProduct,
        loadOriginLocation: loadOriginLocation,
      });
    }
  };
  getLatLngByAddress = async (address) => {
    let data = await geocodeByAddress(address).then((results) => {
      let latlng = getLatLng(results[0])
        .then((latLng) => {
          return latLng;
        })
        .catch((error) => console.error("Error", error));
      return latlng;
    });
    return data;
  };

  onChange(date, dateString) {
    console.log(date, dateString);
  }
  onChangeTime(time, timeString) {
    console.log(time, timeString);
  }
  onSelect(value) {
    console.log("onSelect", value);
  }
  handleSearch = (value) => {
    this.setState({
      dataSource: !value ? [] : [value, value + value, value + value + value],
    });
  };
  hasErrors = (fieldsError) =>
    Object.keys(fieldsError).some((field) => fieldsError[field]);
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        // console.log(values);
        let sizeDetails = this.state?.selectedProduct?.sizes?.filter(
          (size) => size.size === values["size"]
        );
        let totalAmt = this.props.location?.state?.leadData
          ? this.props.location?.state?.leadData?.totalAmt
          : 0;
        if (sizeDetails?.[0]?.[values["type"]?.toLowerCase()]) {
          totalAmt =
            parseFloat(sizeDetails[0][values["type"].toLowerCase()]) *
            parseInt(values["quantity"] ? values["quantity"] : 1);
        }
        if (values["carrier"]) {
          if (
            !values["callForRate"] &&
            (!values["rateOption"] || !values["rateValue"])
          ) {
            message.error("Please select Rate and Rate Option");
            return;
          }
        }
        // if (
        //   values["type"] === "Truckload" &&
        //   parseInt(values["quantity"]) > 1
        // ) {
        //   message.error("Only 1 truckload can be ordered at a time.");
        //   return;
        // } else
        if (parseInt(values["quantity"]) === 0) {
          message.error("Please select valid quantity.");
          return;
        }
        // else if (
        //   values["type"] === "Truckload" &&
        //   totalAmt === 0 &&
        //   !this.props.location?.state?.leadData
        // ) {
        //   // alert("Please select quantity");
        //   message.error(
        //     "This product is currently not available by the Truckload"
        //   );
        //   return;
        // }
        // else if (
        //   values["type"] === "Pallet" &&
        //   totalAmt === 0 &&
        //   !this.props.location?.state?.leadData
        // ) {
        //   // alert("Please select quantity");
        //   message.error(
        //     "This product is currently not available by the Pallet"
        //   );
        //   return;
        // }
        this.setState({
          pageLoading: true,
        });
        const orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        let selectedCustomerLocation =
          this.state?.selectedCustomer?.customerLocations?.filter(
            (location) => location.location === values["loadLocation"]
          );
        // let sizeDetails = this.state.selectedProduct.sizes.filter((size) => size.size === values["size"]);
        // let totalAmt = parseFloat(sizeDetails[0][values["type"].toLowerCase()]) * parseInt(values["quantity"]);
        let productOriginDetails = [];
        this.state.yardLocations.filter((loc) =>
          Array.isArray(values["loadOrigin"])
            ? values["loadOrigin"]?.map((load) => {
                if (loc.locationName === load.toString()) {
                  productOriginDetails.push(loc);
                  console.log(loc);
                }
              })
            : loc.locationName === values["loadOrigin"].toString() &&
              productOriginDetails.push(loc)
        );
        let cartData = [],
          cartIds = [];
        if (this.props.location?.state?.leadData) {
          const orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
          let existingCartData =
            this.props.location?.state?.leadData?.cartItems;
          cartIds = existingCartData.map((item) => {
            return item["id"];
          });
          existingCartData.map((cart, index) => {
            console.log(values[cart["id"] + "_location"]);
            selectedCustomerLocation = orgDetails?.customerLocations?.filter(
              (location) =>
                location.location === values[cart["id"] + "_location"]
            );
            cartData.push({
              id: cart["id"],
              deliveryTruck: cart["deliveryTruck"],
              measurementType: cart["measurementType"],
              productId: cart["productId"],
              productName: cart["productName"],
              productOrigin: cart["productOrigin"],
              quantity: parseInt(cart["quantity"]),
              size: cart["size"],
              totalAmt: cart["totalAmt"],
              amount: cart["amount"],
              poNumber: values[cart["id"] + "_poNumber"],
              locationName: values[cart["id"] + "_location"],
              address: selectedCustomerLocation?.[0]?.["address"],
              notes: values[cart["id"] + "_notes"],
              deliveryReqDate: moment(
                values[cart["id"] + "_deliveryDate"]
              ).format("MM/DD/YYYY"),
              deliveryReqTime:
                moment(values[cart["id"] + "_deliveryStartTime"]).format(
                  "hh:mm A"
                ) +
                " - " +
                moment(values[cart["id"] + "_deliveryEndTime"]).format(
                  "hh:mm A"
                ),
              image: cart["originalPath"],
            });
            return cart;
          });
        } else {
          cartData = [
            {
              id: null,
              deliveryTruck: values["truck"],
              measurementType: values["type"],
              productId:
                Object.keys(this.state?.selectedProduct).length > 0 &&
                this.state?.selectedProduct["id"],
              productName:
                Object.keys(this.state?.selectedProduct).length > 0 &&
                this.state?.selectedProduct["productName"],
              productOrigin: Array.isArray(values["loadOrigin"])
                ? values["loadOrigin"]
                : [values["loadOrigin"]],
              productOriginDetails: productOriginDetails,
              quantity:
                values["type"] === "Truckload"
                  ? 1
                  : parseInt(values["quantity"]),
              size: values["size"],
              totalAmt: totalAmt,
              amount: totalAmt,
              poNumber: values["poNumber"],
              locationName: values["loadLocation"],
              address: selectedCustomerLocation?.[0]?.["address"],
              defeoNotes: values["loadNotes"],
              deliveryReqDate: moment(values["deliveryDate"]).format(
                "MM/DD/YYYY"
              ),
              deliveryReqTime:
                moment(values["deliveryTime"]).format("hh:mm A") +
                " - " +
                moment(values["deliveryEndTime"]).format("hh:mm A"),
              image: sizeDetails?.[0]?.["sizeUploadImg"],
            },
          ];
        }
        let orderStatus = AppConfigs["NEW"];
        let carrierId = null,
          carrierDetails = {},
          pushToCarrier = false,
          assignCarrier = false,
          carrierEmail = null;
        if (values["carrier"]) {
          let carrierInfo = this.state?.carriersList?.filter(
            (c) => c.id === values["carrier"]
          );

          orderStatus = AppConfigs["ASSIGN_TO_CARRIER"];
          carrierId = values["carrier"];
          pushToCarrier = true;
          assignCarrier = true;
          carrierDetails = {
            carrierName: carrierInfo?.[0]?.["companyName"],
            carrierNotes: values["carrierNotes"],
          };
          carrierEmail = carrierInfo?.[0]?.["email"];
        }
        let rateValue = null,
          rateAmt = null,
          rateOption = null,
          quantity =
            values["type"] === "Truckload" ? 1 : parseInt(values["quantity"]);
        if (!values["callForRate"]) {
          rateAmt = values["rateValue"];
          rateOption = values["rateOption"];
          rateValue =
            values["rateOption"] === "measurementType"
              ? parseFloat(values["rateValue"]) * quantity
              : values["rateValue"];
        }
        let data = {
          orderData: {
            customerEmail: this.state?.selectedCustomer?.["email"],
            customerName: null,
            companyName: this.state?.selectedCustomer?.["companyName"],
            pincode: null, //values["pincode"],
            notes: values["loadNotes"],
            subtotal: totalAmt,
            deliveryAmt: 0,
            totalAmt: totalAmt,
            orderStatus: orderStatus,
            pushToCarrier: pushToCarrier,
            assignCarrier: assignCarrier,
            cartItems: cartData,
            customerId: this.state?.selectedCustomer?.["id"],
            carrierId: carrierId,
            customerLatLng: this.props.location?.state?.leadData?.customerLatLng
              ? this.props.location?.state?.leadData?.customerLatLng
              : selectedCustomerLocation?.[0] &&
                "latLng" in selectedCustomerLocation?.[0]
              ? selectedCustomerLocation?.[0]?.["latLng"]
              : null,
            carrierDetails: carrierDetails,
            carrierEmail: carrierEmail,
            rateValue: rateValue,
            rateAmt: rateAmt,
            rateOption: rateOption,
            callForRate: values["callForRate"],
            orgId: orgDetails["id"],
            orgName: orgDetails["orgName"],
            isPalletOrder: this.props.location?.state?.leadData ? true : false,
          },
          cartData: cartIds,
        };
        add(AppConfigs["addOrder"], data).then((result) => {
          if (result.success) {
            message.success("Order placed successfully");
            this.props.history.push("/app/loads");
          } else {
            // message.error(result.errors.message.message);
            this.setState({
              pageLoading: false,
            });
            this.props.history.push("/app/loads");
          }
        });
      }
    });
  };
  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  handleChange(value) {
    console.log(`selected ${value}`);
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  selectCustomer = async (customerId) => {
    let selectedCustomer = this.state.customersList.filter(
      (customer) => customer.id === customerId
    );
    this.setState({
      selectedCustomer: selectedCustomer[0],
      pageLoading: true,
    });
    console.log(selectedCustomer);
    this.props.form.setFieldsValue({
      contactPhone: selectedCustomer[0].phone,
      address: selectedCustomer[0].address,
      loadLocation: "",
      // "city": selectedCustomer[0].city,
      // "state": selectedCustomer[0]["stateText"]
    });
    let query = {
      customerId: customerId,
      isActive: true,
    };
    let productsData = await listProducts(query);
    let selectedProduct = {};
    if (this.props.location?.state?.leadData) {
      selectedProduct = this.state.productsData.filter(
        (product) =>
          product.id === this.props.location?.state?.leadData?.productId
      );
    }
    let BulkGravel = [],
      PalletizedStone = [];
    if (productsData.products["Bulk Gravel"])
      BulkGravel = [...productsData.products["Bulk Gravel"]];
    if (productsData.products["Palletized Stone"])
      PalletizedStone = [...productsData.products["Palletized Stone"]];
    this.setState({
      pageLoading: false,
      productsData: [...BulkGravel, ...PalletizedStone],
      selectedProduct: selectedProduct,
    });
  };

  selectProduct = (productId) => {
    // this.props.form.setFieldsValue({
    //   loadOrigin:'',
    // });
    this.setState({
      pageLoading: true,
    });
    let selectedProduct = this.state.productsData.filter(
      (product) => product.id === productId
    );
    let loadOriginLocation = [];
    this.state.yardLocations.map((loc) => {
      if (Array.isArray(selectedProduct[0].productOrigin)) {
        return selectedProduct[0].productOrigin?.map((item) => {
          if (loc.id === item) loadOriginLocation.push(loc);
        });
      } else {
        if (loc.id === selectedProduct[0].productOrigin)
          loadOriginLocation.push(loc);
      }
    });
    this.props.form.setFieldsValue({
      loadOrigin: undefined,
      size: undefined,
      type: undefined,
      quantity: undefined,
      truck: undefined,
      poNumber: undefined,
      loadNotes: undefined,
    });
    const uniqueIds = [];
    const unique = selectedProduct[0].sizes.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.size);

      if (!isDuplicate) {
        uniqueIds.push(element.size);

        return true;
      }

      return false;
    });
    selectedProduct[0].sizes = unique;
    this.setState({
      selectedProduct: selectedProduct[0],
      pageLoading: false,
      loadOriginLocation: loadOriginLocation,
    });
  };

  render() {
    const { leadData } = this.props.location.state || {};
    console.log("+++", leadData);
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { dataSource, userDetails, isPallet, displayQuantity } = this.state;
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
    };
    if (userDetails.userProfile !== "A" && userDetails.userProfile !== "M") {
      return <ErrorPage />;
    }

    return (
      <div style={{ position: "absolute", top: "135px" }}>
        <Spin spinning={this.state.pageLoading}>
          <Row>
            <Menu
              mode={window.innerWidth < 768 ? "vertical" : "horizontal"}
              style={{ backgroundColor: "rgb(14, 77, 144)" }}
            >
              <Menu.Item key="1">
                <Link to="/app/loads">
                  <h3 style={{ color: "#fff" }}>
                    <ArrowLeftOutlined style={{ fontSize: "1em" }} />
                    Back
                  </h3>
                </Link>
              </Menu.Item>
              <Menu.Item key="2" style={{ cursor: "default" }}>
                <h3 style={{ color: "#fff" }}>New Load: #123456</h3>
              </Menu.Item>
              <Menu.Item key="3" style={{ cursor: "default" }}>
                <h3 style={{ color: "#fff" }}>
                  DISPATCHER :{" "}
                  {this.state.userDetails["firstName"] +
                    " " +
                    this.state.userDetails["lastName"]}
                </h3>
              </Menu.Item>
            </Menu>
          </Row>
          <Row gutter={30} style={{ margin: "40px 20px" }}>
            <div>
              <Form onSubmit={this.handleSubmit}>
                <div>
                  <Col
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ marginBottom: "10px" }}
                  >
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={this.handleSubmit}
                      style={{
                        float: "right",
                        backgroundColor: "#255595",
                        color: "white",
                        marginRight: "30px",
                        padding: "0 20px 0 20px",
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      type="primary"
                      style={{
                        float: "right",
                        backgroundColor: "#25559517",
                        color: "#255595",
                        marginRight: "30px",
                        padding: "0 20px 0 20px",
                        border: "none",
                      }}
                    >
                      <Link to="/app/loads">Cancel</Link>
                    </Button>
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <div className="site-card-border-less-wrapper">
                      <Card
                        title={
                          <h4 className="Companyheadinglabel">
                            1.General Info
                          </h4>
                        }
                        style={{
                          borderRadius: "10px",
                          height: "650px",
                          overflowY: "scroll",
                        }}
                      >
                        <Row gutter={8}>
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Date Ordered
                                </span>
                              }
                            >
                              {/* {getFieldDecorator('dateOrdered', {
                                                                rules: [{ required: true, message: 'Please input Date Ordered!' }],
                                                            })( */}
                              <DatePicker
                                onChange={this.onChange}
                                defaultValue={moment()}
                                format={dateFormat}
                                disabledDate={(current) => {
                                  return (
                                    current && current.valueOf() < Date.now()
                                  );
                                }}
                              />
                              {/* )} */}
                            </Form.Item>
                          </Col>
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Time Ordered
                                </span>
                              }
                            >
                              {/* {getFieldDecorator('timeOrdered', {
                                                                rules: [{ required: true, message: 'Please input Date Ordered!' }],
                                                            })( */}
                              <TimePicker
                                onChange={this.onChangeTime}
                                showNow={true}
                                defaultValue={moment()}
                                format={timeFormat}
                              />
                              {/* )} */}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Customer Name
                                </span>
                              }
                            >
                              {getFieldDecorator("customerName", {
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Please Select your Customer Name!",
                                  },
                                ],
                                initialValue: leadData?.companyName,
                              })(
                                <Select
                                  placeholder="Select customer"
                                  onChange={this.selectCustomer}
                                  showSearch
                                  filterOption={(input, option) =>
                                    option.props.children != null &&
                                    option.props.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {this.state.customersList
                                    .sort((a, b) =>
                                      a.companyName > b.companyName ? 1 : -1
                                    )
                                    .map((customer) => (
                                      <Option
                                        value={customer.id}
                                        key={customer.id}
                                      >
                                        {customer.companyName}
                                      </Option>
                                    ))}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <div style={{ marginTop: "4%" }}>
                              {/* <p style={{fontWeight: 'bold'}}>Customer Details</p>
                                                        <p className="label">Name : <span style={{color: 'black'}}>{this.state.selectedCustomer["companyName"]}</span></p> */}
                              <p className="label">
                                Contact Phone :{" "}
                                <span style={{ color: "black" }}>
                                  {formatPhoneNumber(
                                    this.state.selectedCustomer["phone"]
                                  )}
                                </span>
                              </p>
                              <p className="label">
                                Address :{" "}
                                <span style={{ color: "black" }}>
                                  {this.state.selectedCustomer["address"]}
                                </span>
                              </p>
                            </div>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Location
                                </span>
                              }
                            >
                              {getFieldDecorator("loadLocation", {
                                validateTrigger: ["onChange", "onBlur"],
                                rules: [
                                  {
                                    required: true,
                                    whitespace: true,
                                    message: "Please select location.",
                                  },
                                ],
                                initialValue:
                                  leadData?.["address"] &&
                                  leadData?.["cartItems"]?.[0]?.[
                                    "locationName"
                                  ],
                              })(
                                <Select placeholder="Select location">
                                  {this.state.selectedCustomer[
                                    "customerLocations"
                                  ] &&
                                    this.state.selectedCustomer[
                                      "customerLocations"
                                    ].map((location) => (
                                      <Option
                                        value={location.location}
                                        key={location.location}
                                      >
                                        {location.location}
                                      </Option>
                                    ))}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    </div>
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <div className="site-card-border-less-wrapper loadinfo_card">
                      <Card
                        title={
                          <h4 className="Companyheadinglabel">2.Load Info</h4>
                        }
                        style={{
                          borderRadius: "10px",
                          height: "650px",
                          overflowY: "scroll",
                        }}
                      >
                        <Row gutter={8}>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Product
                                </span>
                              }
                            >
                              {getFieldDecorator("product", {
                                validateTrigger: ["onChange", "onBlur"],
                                rules: [
                                  {
                                    required: true,
                                    whitespace: true,
                                    message: "Please select Product.",
                                  },
                                ],
                                initialValue:
                                  leadData?.["cartItems"] &&
                                  leadData?.["cartItems"]?.[0]?.["productName"],
                              })(
                                <Select
                                  placeholder="Select product name"
                                  onChange={this.selectProduct}
                                  showSearch
                                  filterOption={(input, option) =>
                                    option.props.children != null &&
                                    option.props.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {this.state.productsData.map((product) => (
                                    <Option value={product.id} key={product.id}>
                                      {product.productName}
                                    </Option>
                                  ))}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Load Origin
                                </span>
                              }
                              // initialValue=""
                            >
                              {getFieldDecorator("loadOrigin", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please select your Load Origin!",
                                  },
                                ],
                                initialValue: Array.isArray(
                                  leadData?.["productOriginDetails"]
                                )
                                  ? leadData?.["productOriginDetails"]?.map(
                                      (item) =>
                                        item["address"] &&
                                        `${item["locationName"]}`
                                    )
                                  : leadData?.["productOriginDetails"]?.[
                                      "address"
                                    ] &&
                                    leadData?.["productOriginDetails"]?.[
                                      "locationName"
                                    ],
                                // initialValue: Array.isArray(
                                //   leadData?.["productOrigins"]
                                // )
                                //   ? leadData?.["productOrigins"].map(
                                //       (item) => item
                                //     )
                                //   : leadData?.["productOrigins"],
                                // initialValue:
                                //   leadData["address"] &&
                                //   leadData["productOriginDetails"]?.["locationName"],
                              })(
                                <Select
                                  placeholder="Select load origin"
                                  mode="multiple"
                                  showSearch
                                  filterOption={(input, option) =>
                                    option.props.children != null &&
                                    option.props.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {this.state.selectedProduct &&
                                    this.state.loadOriginLocation.map(
                                      (location) => (
                                        <Option
                                          value={location.id}
                                          key={location.id}
                                        >
                                          {location.locationName}
                                        </Option>
                                      )
                                    )}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Size
                                </span>
                              }
                            >
                              {getFieldDecorator("size", {
                                validateTrigger: ["onChange", "onBlur"],
                                rules: [
                                  {
                                    required: true,
                                    whitespace: true,
                                    message: "Please Select Size",
                                  },
                                ],
                                initialValue:
                                  leadData?.["cartItems"] &&
                                  leadData?.["cartItems"]?.[0]?.["size"],
                              })(
                                <Select placeholder="Select">
                                  {this.state.selectedProduct["sizes"] &&
                                    this.state.selectedProduct["sizes"].map(
                                      (size) => (
                                        <Option
                                          value={size.size}
                                          key={size.size}
                                        >
                                          {size.size}
                                        </Option>
                                      )
                                    )}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Measurement
                                </span>
                              }
                            >
                              {getFieldDecorator("type", {
                                validateTrigger: ["onChange", "onBlur"],
                                rules: [
                                  {
                                    required: true,
                                    whitespace: true,
                                    message: "Please Select Measurement Type.",
                                  },
                                ],
                                initialValue:
                                  leadData?.["cartItems"] &&
                                  leadData?.["cartItems"]?.[0]?.[
                                    "measurementType"
                                  ],
                              })(
                                <Select
                                  placeholder="Select"
                                  onSelect={(value, event) => {
                                    if (value === "Pallet") {
                                      this.setState({
                                        isPallet: true,
                                        displayQuantity: true,
                                      });
                                    } else {
                                      this.setState({
                                        isPallet: false,
                                        displayQuantity: false,
                                      });
                                    }
                                  }}
                                >
                                  {/* <Option value='ton'>Ton</Option> */}
                                  <Option value="Pallet">Pallet</Option>
                                  {/* <Option value='yard'>Yard</Option> */}
                                  <Option value="Truckload">Truckload</Option>
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          {displayQuantity && (
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <Form.Item
                                className="Formitem"
                                label={
                                  <span
                                    style={{
                                      color: "#7B8190",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Quantity
                                  </span>
                                }
                              >
                                {getFieldDecorator("quantity", {
                                  rules: [
                                    {
                                      required: true,
                                      message:
                                        "Please input your Product Quantity!",
                                    },
                                  ],
                                  initialValue:
                                    leadData?.["cartItems"] &&
                                    leadData?.["cartItems"]?.[0]?.["quantity"],
                                })(
                                  <Input
                                    type="number"
                                    placeholder="#"
                                    step={1}
                                    min={1}
                                  />
                                )}
                              </Form.Item>
                            </Col>
                          )}
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Truck
                                </span>
                              }
                            >
                              {getFieldDecorator("truck", {
                                validateTrigger: ["onChange", "onBlur"],
                                rules: [
                                  {
                                    required: true,
                                    // whitespace: true,
                                    message: "Please select Truck.",
                                  },
                                ],
                                initialValue:
                                  leadData?.["cartItems"] &&
                                  leadData?.["cartItems"]?.[0]?.[
                                    "deliveryTruck"
                                  ] &&
                                  Array.isArray(
                                    leadData?.["cartItems"]?.[0]?.[
                                      "deliveryTruck"
                                    ]
                                  )
                                    ? leadData?.["cartItems"]?.[0]?.[
                                        "deliveryTruck"
                                      ]?.map((item) => item)
                                    : leadData?.["cartItems"]?.[0]?.[
                                        "deliveryTruck"
                                      ],
                              })(
                                <Select
                                  placeholder="Select Delivery Truck"
                                  mode={!isPallet && "default"}
                                >
                                  <Option value="Customer Pick Up">
                                    Customer Pick Up
                                  </Option>
                                  {!isPallet && (
                                    <Option value="Tractor Trailer">
                                      Tractor Trailer
                                    </Option>
                                  )}
                                  {!isPallet && (
                                    <Option value="Dump Truck/Triaxle">
                                      Dump Truck/Triaxle
                                    </Option>
                                  )}
                                  {!isPallet && (
                                    <Option value="Mason Dump">
                                      Mason Dump
                                    </Option>
                                  )}
                                  {!isPallet && (
                                    <Option value="Flatbed with forklift">
                                      Flatbed with forklift
                                    </Option>
                                  )}
                                  {!isPallet && (
                                    <Option value="Flatbed">Flatbed</Option>
                                  )}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={<span className="label">PO #</span>}
                            >
                              {getFieldDecorator("poNumber", {
                                rules: [
                                  {
                                    required: false,
                                    message: "Please input your PO",
                                  },
                                ],
                              })(<Input placeholder="PO #" />)}
                            </Form.Item>
                          </Col>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                              className="Formitem"
                              label={
                                <span
                                  style={{ color: "#7B8190", fontSize: "14px" }}
                                >
                                  Pickup Notes:
                                </span>
                              }
                            >
                              {getFieldDecorator("loadNotes", {
                                rules: [
                                  {
                                    required: false,
                                    message: "Please input Notes!",
                                  },
                                ],
                                initialValue:
                                  leadData?.["cartItems"] &&
                                  leadData?.["cartItems"]?.[0]?.["defeoNotes"],
                              })(<TextArea style={{ height: "120px" }} />)}
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    </div>
                  </Col>
                  {/* {Form?.getFieldValue("type") !== "Pallet" && ( */}
                  {!isPallet && (
                    <Col lg={8} md={8} sm={24} xs={24}>
                      <div className="site-card-border-less-wrapper">
                        <Card
                          title={
                            <h4 className="Companyheadinglabel">
                              3.Carrier Info
                            </h4>
                          }
                          style={{
                            borderRadius: "10px",
                            height: "650px",
                            overflowY: "scroll",
                          }}
                        >
                          <Row gutter={8}>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Form.Item
                                className="Formitem"
                                label={
                                  <span
                                    style={{
                                      color: "#7B8190",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Preferred Delivery Date
                                  </span>
                                }
                              >
                                {getFieldDecorator("deliveryDate", {
                                  rules: [
                                    {
                                      required: true,
                                      message: "Please input Delivery Date!",
                                    },
                                  ],
                                  initialValue:
                                    leadData?.["cartItems"] &&
                                    moment(
                                      leadData?.["cartItems"]?.[0]?.[
                                        "deliveryReqDate"
                                      ]
                                    ),
                                })(
                                  <DatePicker
                                    // defaultValue={moment()}
                                    format={dateFormat}
                                    disabledDate={(current) => {
                                      return (
                                        current &&
                                        current.valueOf() < Date.now()
                                      );
                                    }}
                                    // style={{ width: '222px' }}
                                  />
                                )}
                              </Form.Item>
                            </Col>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Form.Item
                                className="Formitem"
                                label={
                                  <span
                                    style={{
                                      color: "#7B8190",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Preferred Delivery Hours
                                  </span>
                                }
                              >
                                <br />
                                <Row gutter={10}>
                                  <Col lg={12} md={12} sm={24} xs={24}>
                                    <Form.Item>
                                      {getFieldDecorator("deliveryTime", {
                                        rules: [
                                          {
                                            required: false,
                                            message: "Please input Start Time!",
                                          },
                                        ],
                                        initialValue:
                                          leadData?.["cartItems"] &&
                                          moment(
                                            leadData?.["cartItems"]?.[0]?.[
                                              "deliveryReqTime"
                                            ]?.split("-")[0],
                                            "hh:mm A"
                                          ),
                                      })(
                                        // <TimePicker use12Hours style={{ width: '222px' }} />
                                        <TimePicker
                                          placeholder="Start Time"
                                          format={timeFormat}
                                          use12Hours
                                          defaultOpenValue={moment(
                                            "00:00",
                                            "hh:mm A"
                                          )}
                                          minuteStep={15}
                                          // open={this.state.startOpen}
                                          onOpenChange={() =>
                                            this.setState({ startOpen: true })
                                          }
                                          onChange={(value) =>
                                            this.setStartValue(
                                              value,
                                              "deliveryTime"
                                            )
                                          }
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col lg={12} md={12} sm={24} xs={24}>
                                    <Form.Item>
                                      {getFieldDecorator("deliveryEndTime", {
                                        rules: [
                                          {
                                            required: false,
                                            message: "Please input End Time",
                                          },
                                        ],
                                        initialValue:
                                          leadData?.["cartItems"] &&
                                          moment(
                                            leadData?.["cartItems"]?.[0]?.[
                                              "deliveryReqTime"
                                            ]?.split("-")[1],
                                            "hh:mm A"
                                          ),
                                      })(
                                        <TimePicker
                                          placeholder="End Time"
                                          format={timeFormat}
                                          use12Hours
                                          defaultOpenValue={moment(
                                            "00:00",
                                            "hh:mm A"
                                          )}
                                          minuteStep={15}
                                          // open={this.state.endOpen}
                                          onOpenChange={(value) =>
                                            this.setEndValue(
                                              value,
                                              "deliveryEndTime"
                                            )
                                          }
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Form.Item>
                            </Col>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Form.Item
                                className="Formitem"
                                label={
                                  <span
                                    style={{
                                      color: "#7B8190",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Carrier
                                  </span>
                                }
                              >
                                {getFieldDecorator("carrier", {
                                  initialValue:
                                    leadData?.["carrierDetails"]?.carrierName,
                                })(
                                  <Select placeholder="Trucking Company Name">
                                    {this.state.carriersList.map((carrier) => (
                                      <Option
                                        value={carrier.id}
                                        key={carrier.id}
                                      >
                                        {carrier.companyName}
                                      </Option>
                                    ))}
                                  </Select>
                                )}
                              </Form.Item>
                            </Col>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Form.Item className="Formitem">
                                {getFieldDecorator("callForRate", {
                                  validateTrigger: ["onChange", "onBlur"],
                                  initialValue: leadData?.["callForRate"],
                                })(
                                  <Checkbox
                                    checked={getFieldValue("callForRate")}
                                  >
                                    Call for Rate
                                  </Checkbox>
                                )}
                              </Form.Item>
                            </Col>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Form.Item
                                className="Formitem"
                                label={
                                  <span
                                    style={{
                                      color: "#7B8190",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Rate
                                  </span>
                                }
                              >
                                {getFieldDecorator("rateValue", {
                                  initialValue: leadData?.["rateAmt"],
                                })(
                                  <Input
                                    placeholder="Rate"
                                    disabled={getFieldValue("callForRate")}
                                  />
                                )}
                              </Form.Item>
                            </Col>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Form.Item className="Formitem">
                                {getFieldDecorator(
                                  "rateOption",
                                  {}
                                )(
                                  <Radio.Group
                                    disabled={getFieldValue("callForRate")}
                                    // value={getFieldValue("rateOption")}
                                  >
                                    <Radio
                                      style={radioStyle}
                                      value={"measurementType"}
                                    >
                                      Ton / Yard / Pallet
                                    </Radio>
                                    <Radio style={radioStyle} value={"flat"}>
                                      Flat Rate
                                    </Radio>
                                  </Radio.Group>
                                )}
                              </Form.Item>
                            </Col>
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Form.Item
                                className="Formitem"
                                label={
                                  <span
                                    style={{
                                      color: "#7B8190",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Delivery Notes:
                                  </span>
                                }
                              >
                                {getFieldDecorator("carrierNotes", {
                                  initialValue:
                                    leadData?.["carrierDetails"] &&
                                    leadData?.["carrierDetails"]?.[
                                      "carrierNotes"
                                    ]
                                      ? leadData?.["carrierDetails"][
                                          "carrierNotes"
                                        ]
                                      : "",
                                  // rules: [{ required: true, message: 'Please input Notes!' }],
                                })(<TextArea style={{ height: "120px" }} />)}
                              </Form.Item>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                  )}
                  {/* )} */}
                </div>
              </Form>
            </div>
          </Row>
          <Modal
            title={<p>Assign load: #1234 to carrier</p>}
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            closable={true}
            footer={[
              <Button
                key="submit"
                className="cancel"
                onClick={this.handleCancel}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                className="assigning"
                onClick={this.handleOk}
              >
                Assign
              </Button>,
            ]}
          >
            {/* <Search className="search"
                        size="large"
                        placeholder="Search"
                    /> */}
            <AutoComplete
              loading
              dataSource={dataSource}
              style={{ width: 400, marginLeft: 40 }}
              onSelect={this.onSelect}
              onSearch={this.handleSearch}
              placeholder="input here"
            />
          </Modal>
        </Spin>
      </div>
    );
  }
}

export default Form.create({ name: "addload" })(withRouter(AddLoad));
